<div class="legacy-dialog-header" mat-dialog-title>
	<div class="legacy-dialog-header-title">Steeluser</div>
	<div class="legacy-dialog-header-subtitle">
		<span translate>login-legacy.privacy-policy</span>
		<button type="button" (click)="closeDialog()">x</button>
	</div>
</div>
<div class="legacy-dialog-body" mat-dialog-content>
	<ul>
		<li><a (click)="privacy.scrollIntoView()" translate>login-legacy.privacy-policy</a></li>
		<li><a (click)="general.scrollIntoView()" translate>login-legacy.general-information-title</a></li>
		<li><a (click)="personal.scrollIntoView()" translate>login-legacy.personal-information-title</a></li>
		<li><a (click)="data.scrollIntoView()" translate>login-legacy.use-of-data-provided-title</a></li>
		<li><a (click)="cookies.scrollIntoView()" translate>login-legacy.use-of-cookies-title</a></li>
		<li><a (click)="analytics.scrollIntoView()" translate>login-legacy.use-of-google-analytics-title</a></li>
		<li><a (click)="prot.scrollIntoView()" translate>login-legacy.protection-of-personal-data-title</a></li>
		<li><a (click)="prop.scrollIntoView()" translate>login-legacy.intellectual-industrial-property-title</a></li>
		<li><a (click)="world.scrollIntoView()" translate>login-legacy.world-wide-transfer-title</a></li>
		<li><a (click)="links.scrollIntoView()" translate>login-legacy.hypertext-links-title</a></li>
		<li><a (click)="resp.scrollIntoView()" translate>login-legacy.responsabilities-title</a></li>
		<li><a (click)="contact.scrollIntoView()" translate>login-legacy.contactus-title</a></li>
	</ul>
	<br />
	<div #privacy><a class="bold" translate>login-legacy.privacy-policy</a></div>
	<div><span translate>login-legacy.privacy-policy-content</span>&ngsp;<a TARGET="_blank" href="http://corporate.arcelormittal.com/investors/corporate-governance/our-policies"><span translate>login-legacy.am-website</span></a></div>
	<br />
	<div #general><a class="bold" translate>login-legacy.general-information-title</a></div>
	<div><span translate>login-legacy.general-information-webservices</span></div>
	<br />
	<div translate>login-legacy.general-information-property</div>
	<br />
	<div #personal><a class="bold" translate>login-legacy.personal-information-title</a></div>
	<div><span translate>login-legacy.personal-information-content</span></div>
	<br />
	<div #data><a class="bold" translate>login-legacy.use-of-data-provided-title</a></div>
	<div><span translate>login-legacy.use-of-data-provided-responses</span></div>
	<br />
	<div><span translate>login-legacy.use-of-data-provided-consult-rectify</span>&ngsp;<a TARGET="_blank" href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support@arcelormittal.com</a></div>
	<br />
	<div #cookies><a class="bold" translate>login-legacy.use-of-cookies-title</a></div>
	<div><span translate>login-legacy.use-of-cookies-installed</span></div>
	<br />
	<div><span translate>login-legacy.use-of-cookies-navigation</span></div>
	<br />
	<ul>
		<li><span translate>login-legacy.if-you-are-using</span>&ngsp;<span class="bold" translate>login-legacy.ie-11</span>:&ngsp;<a target="_blank" href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"><span translate>login-legacy.click-here</span></a></li>
		<li><span translate>login-legacy.if-you-are-using</span>&ngsp;<span class="bold" translate>login-legacy.firefox</span>:&ngsp;<a target="_blank" href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"><span translate>login-legacy.click-here</span></a></li>
		<li><span translate>login-legacy.if-you-are-using</span>&ngsp;<span class="bold" translate>login-legacy.chrome</span>:&ngsp;<a target="_blank" href="https://support.google.com/chrome/answer/95647?hl=en"><span translate>login-legacy.click-here</span></a></li>
	</ul>
	<br />
	<div translate>login-legacy.useofcookies-refusing-content</div>
	<br />
	<br />
	<div #analytics><a class="bold" translate>login-legacy.use-of-google-analytics-title</a></div>
	<div><span translate>login-legacy.use-of-google-analytics-content</span>&ngsp;<a target="_blank" href="https://www.google.com/policies/privacy/partners/">www.google.com/policies/privacy/partners/</a></div>
	<br />
	<div #prot><a class="bold" translate>login-legacy.protection-of-personal-data-title</a></div>
	<div><span translate>login-legacy.protection-of-personal-data-secrecy</span></div>
	<br />
	<div><span translate>login-legacy.protection-of-personal-data-communication</span></div>
	<br />
	<div><span translate>login-legacy.protection-of-personal-data-2-years</span></div>
	<br />
	<div><span translate>login-legacy.protection-of-personal-data-abuse</span></div>
	<br />
	<div><span translate>login-legacy.protection-of-personal-data-responsible</span></div>
	<br />
	<div #prop><a class="bold" translate>login-legacy.intellectual-industrial-property-title</a></div>
	<div><span translate>login-legacy.intellectual-industrial-property-content</span></div>
	<br />
	<div #world><a class="bold" translate>login-legacy.world-wide-transfer-title</a></div>
	<div><span translate>login-legacy.world-wide-transfer-content</span></div>
	<br />
	<div #links><a class="bold" translate>login-legacy.hypertext-links-title</a></div>
	<div><span translate>login-legacy.hypertext-links-content</span></div>
	<br />
	<div #resp><a class="bold" translate>login-legacy.responsabilities-title</a></div>
	<div><span translate>login-legacy.responsabilities-content</span></div>
	<br />
	<div #contact><a class="bold" translate>login-legacy.contactus-title</a></div>
	<div><span translate>login-legacy.contactus-please</span></div>
	<div><span translate>login-legacy.contactus-address</span></div>
	<div><span translate>login-legacy.contactus-by-email</span>&ngsp;<a target="_blank" href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support@arcelormittal.com</a></div>
	<br />
</div>
